/**
 * Тип анимации.
 */
export enum Type {
  /**
   * Префикс глобальных имён классов.
   */
  FADE = 'fade-transition',
}
